import { ArticleCard } from '#/components/ui/ArticleCard';
import { SectionHeader } from '#/components/ui/SectionHeader';
import type { ContentArticleCard } from '#/content/lib';
import { cn } from '#/utils/cn';

interface LearnMoreSectionProps {
  title?: string;
  articles?: ContentArticleCard[];
  /** Section anchor id, e.g. for sticky-nav scroll targets. */
  id?: string;
  /** GTM `data-track` id forwarded onto each article card anchor. */
  articleTrack?: string;
  /** GTM `data-track-context` forwarded onto each article card anchor. */
  articleTrackContext?: string;
}

export function LearnMoreSection({
  title,
  articles,
  id = 'learn-more',
  articleTrack,
  articleTrackContext,
}: LearnMoreSectionProps = {}) {
  const articleHeadingLevel = title ? 'h3' : 'h2';

  return (
    <section id={id} className="flow flow-inner-20 scroll-mt-(--scroll-offset)">
      {title && <SectionHeader title={title} actionAlignment="center" />}
      {articles ? (
        <div
          className={cn(
            'grid gap-20',
            articles.length === 2 && 'lg:grid-cols-2',
            articles.length >= 3 && 'lg:grid-cols-3',
          )}
        >
          {articles.map((article) => (
            <ArticleCard
              key={article.href}
              title={article.title}
              content={article.summary}
              href={article.href}
              headingLevel={articleHeadingLevel}
              dataTrack={articleTrack}
              dataTrackLabel={articleTrack ? article.title : undefined}
              dataTrackContext={articleTrackContext}
            />
          ))}
        </div>
      ) : (
        <p>Learn more placeholder</p>
      )}
    </section>
  );
}
